export const defaultLocale = window.ocm?.config?.language ?? "de";
export const fallbackLocale = "en";
